import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import VueNode from "../views/VueNode.vue";
import VueSB from "../views/VueSb.vue";
import HomeWork from "../views/HomeWork.vue";
import Detail from "../views/Detail.vue";
import WxApp from "../views/WxApp.vue";
import Search from "../views/Search.vue";
Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/Home" },
  { path: "/Home", component: Home },
  { path: "/VueNode", component: VueNode },
  { path: "/VueSB", component: VueSB },
  { path: "/HomeWork", component: HomeWork },
  { path: "/WxApp", component: WxApp },
  { path: "/Detail", component: Detail },
  { path: "/Search", component: Search },
];

const router = new VueRouter({
  routes,
});

export default router;
